import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {usePphListModel} from "@/stores/models/pph-list-model";

export const usePphListStore  = defineStore(
    'pphListStore',
    () => {
       
        const isLoading = ref(false);
        const selectedPegawai = ref(null);
        const dataSourcePphList = ref(
            new DataSource({
                requireTotalCount: true,
                store: usePphListModel().pphListCustomStore,
                filter: null,
            })
        );

        // const dataSourcePendidikanList = (additionalParams = null) => {
        //     // console.log('masuk dataSourcePendidikanList', additionalParams)
        //     return new DataSource({
        //       requireTotalCount: true,
        //       load: (loadOptions) => {
        //         // Handle load options and additionalParams separately
        //         return usePendidikanListModel().pendidikanListCustomStore.load([loadOptions, additionalParams]);
        //       }
        //     });
        // };

        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourcePphList.value.reload();
        };

        const initialized = ()=>{     
            dataSourcePphList.value.reload();
        };

        return {
            dataSourcePphList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state,
            selectedPegawai

        }
    }
);